import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';
import Quill from 'quill';

import attachment from './attachments/attachment';
import download from './attachments/download';
import searchableSelectPaginate from './searchable-select-paginate';
import search from './search';
import initSelect from './select';
import livewireModal from './livewire-modal';
import * as uploadFromBase64 from './attachments/uploadFromBase64'
import bindScreenWidth from './bindScreenWidth'
import flexTable from './flexTable';
import editMode from './editMode';
import dragAndDrop from './attachments/dragAndDrop';
import keywordCombobox from './keyword-combobox';
import uploadProgress from './attachments/upload-progress';

import '../utils';

window.initSelect = initSelect;
window.searchableSelectPaginate = searchableSelectPaginate;
window.attachment = attachment;
window.Quill = Quill;
window.search = search;
window.uploadFromBase64 = uploadFromBase64;
window.flexTable = flexTable;
window.dragAndDrop = dragAndDrop;
window.editMode = editMode;
window.uploadProgress = uploadProgress;

Alpine.data('initSelect', initSelect);
Alpine.data('searchableSelectPaginate', searchableSelectPaginate);
Alpine.data('attachment', attachment);
Alpine.data('download', download);
Alpine.data('search', search);
Alpine.data('bindScreenWidth', bindScreenWidth);
Alpine.data('flexTable', flexTable);
Alpine.data('editMode', editMode);
Alpine.data('livewireModal', livewireModal);
Alpine.data('dragAndDrop', dragAndDrop);
Alpine.data('keywordCombobox', keywordCombobox);
Alpine.data('uploadProgress', uploadProgress);
